"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingInvitationsForOfficeResponseSchema = exports.pendingInvitationForOfficeItemSchema = void 0;
const zod_1 = require("zod");
exports.pendingInvitationForOfficeItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string().email(),
    slotCount: zod_1.z.number().int().nonnegative(),
    expiresAt: zod_1.z.string().datetime(),
});
exports.getPendingInvitationsForOfficeResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.pendingInvitationForOfficeItemSchema),
});
